var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoEligibleSchools(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 147,
    height: 153,
    viewBox: "0 0 147 153",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "School",
    filter: "url(#filter0_dd_1458_11368)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.8945 107.999H29.8945V119.999H125.105V107.999H119.105V77.0967H35.8945V107.999ZM61.0001 86.9992H49.0001V98.9992H61.0001V86.9992ZM97 86.9992H109V98.9992H97V86.9992ZM76.0004 86.9992C74.3435 86.9992 73.0004 88.3423 73.0004 89.9992V107.999C73.0004 109.656 74.3435 110.999 76.0004 110.999H82.0004C83.6572 110.999 85.0004 109.656 85.0004 107.999V89.9992C85.0004 88.3423 83.6572 86.9992 82.0004 86.9992H76.0004Z",
    fill: "url(#paint0_linear_1458_11368)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 4",
    x: 35.8945,
    y: 77.0967,
    width: 83.2105,
    height: 3.67742,
    fill: "#DAE1EE",
    fillOpacity: 0.46
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 1",
    d: "M31 77.5605H124L112 50.5605H94L79 35.5605L64 50.5605H46L31 77.5605Z",
    fill: "url(#paint1_linear_1458_11368)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 2",
    d: "M79 41.5605L55 68.5605H103L79 41.5605Z",
    fill: "url(#paint2_linear_1458_11368)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 4",
    d: "M103.197 19.4651C101.158 20.1481 96.2631 20.6946 92.9999 17.4159C86.4736 12.4979 80.7631 12.6512 78.7236 14.7004V25.6126C78.7236 24.2464 80.7631 21.9241 88.921 23.5634C97.0789 25.2027 101.838 21.5142 103.197 19.4651Z",
    fill: "url(#paint3_linear_1458_11368)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 3",
    d: "M77.5 12.5605V37.0582L78.8882 35.8898L79.9474 36.5041V12.5605C79.9474 12.0083 79.4997 11.5605 78.9474 11.5605H78.5C77.9477 11.5605 77.5 12.0083 77.5 12.5605Z",
    fill: "url(#paint4_linear_1458_11368)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 1",
    cx: 79.0005,
    cy: 56.5615,
    rx: 6,
    ry: 6,
    fill: "#D6DFEA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 5",
    d: "M108.704 67.2906L94.6313 50.7422H112.375L117.881 64.839L108.704 67.2906Z",
    fill: "url(#paint5_linear_1458_11368)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 6",
    d: "M49.9672 67.2906L64.0396 50.7422H46.2961L40.7896 64.839L49.9672 67.2906Z",
    fill: "url(#paint6_linear_1458_11368)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M43.6407 40.261L38.9038 29.29",
    stroke: "#989FB0",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    d: "M38.4594 45.4467L23.6577 34.917",
    stroke: "#989FB0",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    d: "M35.3513 52.421L24.8423 51.8204",
    stroke: "#989FB0",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    d: "M113 41.971L117.737 31",
    stroke: "#989FB0",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    d: "M118.392 47.4467L133.193 36.917",
    stroke: "#989FB0",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    d: "M121.5 54.421L132.009 53.8204",
    stroke: "#989FB0",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_1458_11368",
    x: 0.657715,
    y: -5,
    width: 155.536,
    height: 158,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.396078 0 0 0 0 0.478431 0 0 0 0 0.576471 0 0 0 0.27 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1458_11368"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.396078 0 0 0 0 0.478431 0 0 0 0 0.576471 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_1458_11368",
    result: "effect2_dropShadow_1458_11368"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_1458_11368",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1458_11368",
    x1: 77.4999,
    y1: 77.0967,
    x2: 77.4999,
    y2: 119.999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCFDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEF2F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1458_11368",
    x1: 77.5,
    y1: 35.5605,
    x2: 77.5,
    y2: 77.5605,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#979FAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1BBCD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1458_11368",
    x1: 79,
    y1: 68.5163,
    x2: 79,
    y2: 41.5486,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0F4F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCFDFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1458_11368",
    x1: 87.1403,
    y1: 15.9752,
    x2: 100.833,
    y2: 19.2594,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E879F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AAB3C5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1458_11368",
    x1: 79.0003,
    y1: 11.5605,
    x2: 79.0003,
    y2: 38.5605,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF1F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1458_11368",
    x1: 103.197,
    y1: 59.9357,
    x2: 111.159,
    y2: 55.0448,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E879F",
    stopOpacity: 0.38
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7E879F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1458_11368",
    x1: 55.4738,
    y1: 59.9357,
    x2: 47.5122,
    y2: 55.0448,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E879F",
    stopOpacity: 0.38
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7E879F",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoEligibleSchools);
export default __webpack_public_path__ + "static/media/no-eligible-schools.5df563c48602a49293095fdcf3f16a5d.svg";
export { ForwardRef as ReactComponent };